var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';
var SelfieCaptureModalComponent = /** @class */ (function (_super) {
    __extends(SelfieCaptureModalComponent, _super);
    function SelfieCaptureModalComponent(ref, elRef, renderer) {
        var _this = _super.call(this, elRef, renderer) || this;
        _this.ref = ref;
        _this.elRef = elRef;
        _this.renderer = renderer;
        _this.initiliaze = false;
        _this.allowCapture = false;
        _this.captured = false;
        _this.cameraNotAllowed = false;
        _this._constraints = { video: true };
        return _this;
    }
    SelfieCaptureModalComponent.prototype.ngAfterViewInit = function () { };
    SelfieCaptureModalComponent.prototype.ngOnDestroy = function () {
        this.stop();
    };
    SelfieCaptureModalComponent.prototype.close = function () {
        this.ref.close();
    };
    SelfieCaptureModalComponent.prototype.reject = function () {
        this.ref.dismiss();
    };
    SelfieCaptureModalComponent.prototype.submit = function () {
        this.ref.close({ image: this._capturedImage });
    };
    SelfieCaptureModalComponent.prototype.capture = function () {
        var canvas = this.canvasElement.nativeElement;
        var video = this.videoElement.nativeElement;
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0);
        this._capturedImage = canvas.toDataURL('image/png');
        this.captured = true;
    };
    SelfieCaptureModalComponent.prototype.stop = function () {
        if (this.videoElement && this.videoElement.nativeElement) {
            this.videoElement.nativeElement.pause();
        }
        if (!this._localMediaStream) {
            return;
        }
        try {
            this._localMediaStream.stop();
        }
        catch (e) {
            for (var _i = 0, _a = this._localMediaStream.getVideoTracks(); _i < _a.length; _i++) {
                var track = _a[_i];
                track.stop();
            }
        }
    };
    SelfieCaptureModalComponent.prototype.handleCameraSuccess = function (stream) {
        this.allowCapture = true;
        this.cameraNotAllowed = false;
        this._localMediaStream = stream;
        this.videoElement.nativeElement.srcObject = stream;
    };
    SelfieCaptureModalComponent.prototype.handleError = function (error) {
        this.cameraNotAllowed = true;
    };
    SelfieCaptureModalComponent.prototype.initializeCamera = function () {
        this.initiliaze = true;
        window.navigator.mediaDevices
            .getUserMedia(this._constraints)
            .then(this.handleCameraSuccess.bind(this))
            .catch(this.handleError.bind(this));
    };
    return SelfieCaptureModalComponent;
}(AnimatedModalComponent));
export { SelfieCaptureModalComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/selfie-capture-modal.component.ts.pre-build-optimizer.js